import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import axios from "../config/axiosWithLocation";

export const fetchAllOrders = createAsyncThunk(
  "orders/fetchAllOrders",
  async (payload, thunkApi) => {
    const response = await axios
      .get("/orders")
      .then((res) => res.data.orders.reverse())
      .catch((error) =>
        thunkApi.rejectWithValue(
          error.response.data.message ||
            "Something went wrong. Please try again later."
        )
      );
    return response;
  }
);

const initialState = {
  orders: null,
  error: null,
  isLoading: false,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    updateOrder(state, action) {
      const index = current(state).orders.findIndex(
        (order) => order.id === action.payload.id
      );
      state.orders[index].status = action.payload.status;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllOrders.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAllOrders.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.orders = action.payload;
    });
    builder.addCase(fetchAllOrders.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { updateOrder } = orderSlice.actions;

export default orderSlice.reducer;
